import React, { useState } from 'react';
import ImageWrapper from '../Image/ImageWrapper';
import Spinner from '../Spinner/Spinner';

import './index.scss';

function VideoPlayer({ video, thumbnail = null, toggleModal }) {
  const [isFullScreen, setIsFullScreen] = useState(toggleModal || false);
  const [isLoading, setIsLoading] = useState(true);

  const handleOnPlayVideo = () => {
    setIsFullScreen(true);
    setIsLoading(true);
    document.body.style.overflow = 'hidden';
  };

  const handleOnCloseVideo = () => {
    setIsFullScreen(false);
    document.body.style.overflow = '';
  };

  const getYoutubeVideoSrc = () => {
    const url = video?.url ?? video.source.url;
    const videoIdMatch = url?.match(/(?:v=|\/shorts\/)([^&?/]+)/);
    const videoId = videoIdMatch ? videoIdMatch[1] : null;

    if (!videoId) {
      console.error('VideoPlayer: Invalid video URL.');
      return null;
    }

    return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  };

  const getVideoThumbnail = () => {
    return video?.source ? { url: video.source.thumbnailUrl } : { url: video?.thumbnailUrl };
  };

  if (!video) return null;

  return (
    <div className="video-player">
      {isFullScreen ? (
        <div className="fullscreen">
          <span onClick={handleOnCloseVideo}>Close</span>
          {isLoading && (
            <div className="spinner">
              <Spinner />
            </div>
          )}

          <iframe
            src={getYoutubeVideoSrc()}
            onLoad={() => setIsLoading(false)}
            style={isLoading ? { display: 'none' } : {}}
          />
        </div>
      ) : (
        <div className="thumbnail" onClick={handleOnPlayVideo}>
          <ImageWrapper image={thumbnail || getVideoThumbnail()} />

          <svg xmlns="http://www.w3.org/2000/svg" width="86" height="86" viewBox="0 0 86 86" fill="none">
            <circle cx="43" cy="43" r="43" fill="#011C25" />
            <path d="M34 29V58L58.4211 43.5L34 29Z" fill="#FAF9F6" />
          </svg>
        </div>
      )}
    </div>
  );
}

export default VideoPlayer;
